// extracted by mini-css-extract-plugin
export default {"faqSlider":"FAQSlider_faqSlider__qljOI","arrowButton":"FAQSlider_arrowButton__RCdX4"};